import { Navigate, useLocation } from 'react-router-dom';

/** `/finance…` → `/insights…` — 경로 앞부분만 바꾸고 쿼리(`embed`·`theme`·`category`)·해시(`#map`)는 그대로. 순수 함수(테스트용 export). */
export const toInsightsPath = (pathname: string, search: string, hash: string): string =>
  `${pathname.replace(/^\/finance(?=\/|$)/, '/insights')}${search}${hash}`;

export const LegacyFinanceRedirect = () => {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={toInsightsPath(pathname, search, hash)} replace />;
};
